import { useContext } from 'react';
import { datadogRum } from '@datadog/browser-rum';

import { RumComponentContext } from './rum-component-context';
import { addRUMAction } from '../utils/RUMHelpers';
import { ActionName, Context } from '../../types';

/**
 * Utility to track actions in RUM with the component chain/breadcrumbs from <RumComponentContextProvider> automatically added
 *
 * add a "purpose" to the custom attributes to group the actions
 *
 *
 * @param purpose: explains the use case for the action, allows to split performance and user-tracking actions for example
 */
export const useRumAction = (purpose = 'unknown') => {
  const componentContext = useContext(RumComponentContext);

  if (!datadogRum) {
    console.warn('@datadog/rum-react-integration: Datadog RUM SDK is not initialized.'); // eslint-disable-line
    return () => ({});
  }
  return (name: string, context?: Context) => {
    const actionName: ActionName = {
      name,
      teamName: componentContext.teamName,
      productName: componentContext.productName,
    };

    addRUMAction(actionName, {
      purpose,
      ...componentContext.customAttributes,
      ...context,
      react: {
        breadcrumbs: componentContext.componentBreadCrumbs,
        component: componentContext.component,
        ...(context as any)?.react,
      },
    });
  };
};
